/**
 * Konwertuje błędy walidacji (z klasy wyjątku ValidationException) na miadomości typu MessagesBag\Message
 * @param {Object} errors Obiekt errors zwrócony z serwera: errors: { fieldName: [...errors]}
 * @return {Array}
 */
import {errorAlert} from "../alerts.js";
import {createErrorToast} from "../toast-messages/toast-messages.js";

export const convertServerValidationErrorsToMessages = (errors) => {
    let error, field;
    const messages = [];
    for (field in errors) {
        if (errors.hasOwnProperty(field)) {
            for (error of errors[field]) {
                messages.push({
                    type: 'danger',
                    content: error
                });
            }
        }
    }
    return messages;
};

/**
 * Konwertuje błędy zapytań AJAX na stringi do wyświetlenia
 * @param response
 * @returns {string}
 */
export const convertAjaxResponseErrorMessageToString = response => {
    if (response && _.isString(response)) {
        return response;
    }

    if (response && response.responseJSON && _.isObject(response.responseJSON.errors) && !_.isArray(response.responseJSON.errors)) {
        const errors = _.values(response.responseJSON.errors).reduce((acc, err) => [...acc, ...err]);
        return errors.join('\n');
    }

    if (response && response.responseJSON && _.isArray(response.responseJSON.errors)) {
        return response.responseJSON.errors.join('\n');
    }

    if (response && response.responseJSON && response.responseJSON.error) {
        return String(response.responseJSON.error);
    }

    if (response instanceof Error && response.message) {
        return response.message;
    }

    return 'Wystąpił błąd';
};

/**
 * Konwertuje błędy zapytań AJAX na błędy walidacji z serwera
 * @param {*} response
 * @param {Boolean} splitPaths
 * @returns {object}
 */
export const convertAjaxResponseErrorToValidationErrors = (response, splitPaths = false) => {
    if (response && response.responseJSON && _.isObject(response.responseJSON.errors) && !_.isArray(response.responseJSON.errors)) {
        if (splitPaths) {
            const errors = {};
            for (let field in response.responseJSON.errors) {
                _.set(errors, field, response.responseJSON.errors[field]);
            }
            return errors;
        }
        return response.responseJSON.errors;
    }
    return {};
};

/**
 * @param {any} error
 * @param {boolean | Partial<ToastMessage> & {
 *     log?: boolean,
 *     useToasts?: boolean,
 * }} options
 * @return {string|string[]|Object}
 */
export const showErrorPopup = (error, options = true) => {
    if (typeof options !== 'object') {
        options = {
            log: options,
        };
    }

    const errors = convertAjaxResponseErrorMessageToString(error).split('\n');
    if (options.useToasts) {
        createErrorToast(errors.join('<br>'), options);
    } else {
        for (let message of errors) {
            errorAlert(message);
        }
    }

    if (options.log !== false) {
        console.error(error);
    }
    return errors;
};

/**
 * @param {jQuery|string|HTMLElement} $form
 * @param {Object|null} errors
 */
export const showValidationErrors = ($form, errors= {}) => {
    var $input, $group, fieldErrors, $errorsContainer;
    $form = jQuery($form);
    $form.find('.has-error').removeClass('has-error');
    $form.find('.is-invalid').removeClass('is-invalid');
    $form.find('.validation-errors-container').empty();
    if (errors && typeof errors.hasOwnProperty === 'function') {
        for (var field in errors) {
            if (errors.hasOwnProperty(field)) {
                $input = $form.find('[name="' + field + '"]');
                $group = $input.parents('.form-group:first, td, .form-control-container, .input-group');
                $errorsContainer = $group.find('.validation-errors-container');
                fieldErrors = errors[field] || [];
                if (fieldErrors.length > 0) {
                    $group.addClass('has-error');
                    $input.addClass('is-invalid')
                    if ($errorsContainer.length === 0) {
                        $errorsContainer = jQuery('<div>', {class: 'validation-errors-container invalid-feedback text-danger px-2'});
                        $group.append($errorsContainer);
                        $errorsContainer.show();
                    }
                    $errorsContainer.append(fieldErrors.map(function (error) {
                        return jQuery('<p>', {class: 'p-0 m-0'}).html(error);
                    }));
                }
            }
        }
    }
};


export const clearValidationErrors = form => {
    showValidationErrors(form, null);
};


/**
 * @param {Object} sources
 * @returns {Object}
 */
export const mergeValidationErrors = (...sources) => {
    const target = {};
    let source, field;
    for (source of sources) {
        for (field in source) {
            if (source.hasOwnProperty(field) && source[field]) {
                target[field] = [
                    ...(target[field] || []),
                    ...source[field],
                ];
            }
        }
    }
    return target;
};

/**
 *
 * @param {Object} errors
 * @param {String} field
 * @param {String} message
 * @returns {Object}
 */
export const addValidationError = (errors, field, message) => {
    if (!errors) {
        errors = {};
    }
    if (!errors[field]) {
        errors[field] = [];
    }
    errors[field].push(message);
    return errors;
};

export const removeValidationError = (errors, field) => {
    _.set(errors, field, undefined);
    return errors;
}

/**
 * @param {Object} errors
 * @returns {Boolean}
 */
export const hasValidationErrors = errors => {
    let field;
    for (field in errors) {
        if (errors.hasOwnProperty(field) && errors[field] && errors[field].length > 0) {
            return true;
        }
    }
    return false;
};

/**
 * @param {Object} errors
 * @param {String} field
 * @returns {Boolean}
 */
export const hasFieldValidationErrors = (errors, field) => {
    return errors && errors[field] && errors[field].length > 0;
};

/**
 * Spłaszcza błędy walidacji
 * @param {Object} errors
 * @returns {string[]}
 */
export const flattenValidationErrors = errors => {
    const flattenErrors = [];
    let field, fieldError;
    for (field in errors) {
        for (fieldError of errors[field]) {
            flattenErrors.push(fieldError);
        }
    }
    return flattenErrors;
};
